import {
  PATROLSUPERVISELIST} from '../actions/patrolSupervise';

import {reducerPackage} from "../../utils";

export const patrolSuperviseList = reducerPackage(PATROLSUPERVISELIST);

